/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_Col_AmountInputs */

const vi_einvoice_draft_col_amount = /** @type {(inputs: Einvoice_Draft_Col_AmountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiền hàng`)
};

/**

* @param {Einvoice_Draft_Col_AmountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_col_amount = /** @type {((inputs?: Einvoice_Draft_Col_AmountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_Col_AmountInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_col_amount(inputs)
});